import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RevampDesignService } from './revamp-design.service';

/**
 * Floating QA toggle between the classic and revamped header/footer,
 * shown only while the headerFooterRedesign feature flag grants access
 * (mirrors the sales-page design toggle). Stacked above the sales-page
 * pill, which sits at bottom: 16px on course pages.
 */
@Component({
  selector: 'revamp-design-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      class="revamp-toggle"
      type="button"
      (click)="design.toggleDesign()"
      [attr.aria-label]="design.useNewDesign() ? 'Switch to classic navigation' : 'Switch to new navigation'"
    >
      <span class="dot" [class.on]="design.useNewDesign()"></span>
      {{ design.useNewDesign() ? 'Classic navigation' : 'New navigation ✨' }}
    </button>
  `,
  styles: [
    `
      .revamp-toggle {
        position: fixed;
        left: 16px;
        bottom: 62px;
        z-index: 1000;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 9px 16px;
        border-radius: 999px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        background: #ffffff;
        color: #333;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
        transition: transform 0.15s ease, box-shadow 0.15s ease;
      }
      .revamp-toggle:hover {
        transform: translateY(-1px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);
      }
      .revamp-toggle .dot {
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: #bbb;
        flex: none;
      }
      .revamp-toggle .dot.on {
        background: #22a06b;
      }
      @media (max-width: 940px) {
        /* keep clear of the sales-page toggle, which moves up on mobile */
        .revamp-toggle {
          bottom: 130px;
        }
      }
    `,
  ],
})
export class RevampDesignToggleComponent {
  readonly design = inject(RevampDesignService);
}
